module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av381-b3c934e2b27fffe5e7c94b2e4015d607.jpg";